/** API payloads may omit rate blocks; coerce to { disabled, rate } */
export default function normalizeRate(rate) {
    if (rate && typeof rate === "object") {
        return {
            disabled: Boolean(rate.disabled),
            rate: Number(rate.rate) || 0,
        };
    }
    return { disabled: false, rate: 0 };
}
